<side-panel-header [displayText]="customLabel"></side-panel-header>
@for (attribute of attributeList; track attribute) {
  @if (attribute.prop) {
    <div class="SidePanel__action" (click)="handleCustomAction(attribute.prop)">
      <icon
        [name]="attribute.icon ? attribute.icon : 'pdf'"
        [config]="{
          format: 'svg',
          type: 'link',
          size: 'medium',
        }"
      >
      </icon>
      <p class="SidePanel__label t-bold t-link">{{ attribute.label }}</p>
    </div>
  }
}
